import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: 'inherit',
  },
  division: {
    width: '1px',
    height: '23%',
    margin: '0 7px',
    backgroundColor: theme.palette.primary.division,
  },
}));

/**
 * 컬럼 설정 관련 WRAP
 * @param children
 * @param rest
 * @returns {*}
 * @constructor
 */
const DivisionWrap = ({ children, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={classes.root} {...rest}>
      {Array.isArray(children)
        ? children.map((el, index) => (
            <React.Fragment key={index}>
              {index !== 0 && <div className={classes.division} />}
              <div>{el}</div>
              {index !== 0 && <div className={classes.division} />}
            </React.Fragment>
          ))
        : children}
    </div>
  );
};

export default DivisionWrap;
